module.exports = __webpack_public_path__ + "static/interview_2-35b871012018e701a2856e0d1dad6ba2.m4a";